import {get} from 'aws-amplify/api';
import {Command, type GetMethod} from '../../Command';

import type {GetOrganizationResponse} from '../../../dto/organization/GetOrganizationResponse';

export class GetOrganizationCommand extends Command<GetMethod, GetOrganizationResponse> {
  constructor() {
    super(get, {
      path: `/organization/me`,
    });
  }

  async deserialize(output: ReturnType<typeof get>): Promise<GetOrganizationResponse> {
    const {body} = await output.response;
    return await (body.json() as unknown as Promise<GetOrganizationResponse>);
  }
}
